import styled from 'styled-components';
import { BulletedListProps } from '../../../components/ToolkitV2/BulletedList/BulletedList.typed';

const BulletedList = styled.ul<BulletedListProps>`
  list-style: none;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  gap: ${({ theme }) => theme.spacing.S4};
`;

export { BulletedList };
